<template>
  <div class="stepper-container">
    <button class="scroll-btn left text-primary" @click="scrollLeft">⬅</button>
    
    <div ref="stepperNav" class="row step-nav flex-nowrap w-100 overflow-x-auto">
      <div v-for="(step, index) in stepCount" 
           :key="'step-nav-item-'+index" 
           class="col"
           :class="{ 'completed': model === step?.id }"
           @click="handleStepPress(step?.id)">
        <div class="step-nav-item" 
             :class="[
               { 'active': model === step?.id },
               { 'completed': model === step?.id }
             ]">
          <i v-if="!step" class="fas fa-check-square me-2"></i>
          <span v-else class="badge badge-square badge-light p-1 me-2">{{parseInt(step?.milestone_categories_progress)}}%</span>

          <span class="fs-6 fw-bold me-3"> 
            {{ step ? step?.title : `${$t('step')} ${index}` }} 
          </span>
          <slot :step="step" :index="index"/>

        </div>
      </div>
    </div>
    
    <button class="scroll-btn right text-primary" @click="scrollRight">➡</button>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

const model = defineModel();

const props = defineProps({
  stepCount: { type: [Number , Array], required: true },
  activeStep: String
});

const stepperNav = ref(null);

watch(() => props.activeStep, () => {
  model.value = props.activeStep;
});

const handleStepPress = (i) => {
  model.value = i;
};

// Gestion du scroll horizontal
const scrollLeft = () => {
if (stepperNav.value) {
  stepperNav.value.scrollBy({ left: -200, behavior: "smooth" });
}
};

const scrollRight = () => {
if (stepperNav.value) {
  stepperNav.value.scrollBy({ left: 200, behavior: "smooth" });
}
};

onMounted(() => {
model.value = props.activeStep;
});
</script>

<style scoped>
.stepper-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

.step-nav {
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none; /* Masque la scrollbar */
  -ms-overflow-style: none;
}

.step-nav::-webkit-scrollbar {
  display: none; /* Cache la scrollbar sur Chrome/Safari */
}

.scroll-btn {
  background: var(--bs-light-primary);
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scroll-btn.left {
  margin-right: 15px;
}

.scroll-btn.right {
  margin-left: 15px;
}

/* Styles des étapes */
.step-nav .col {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.step-nav-item {
  padding: 10px 8px;
  border: 1px solid var(--bs-light-primary);
  border-radius: 5px;
  color: var(--bs-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  background-color: white;
  z-index: 10;
  min-width: 120px;
}

/* Étape active */
.step-nav-item.active {
  border-color: var(--bs-primary);
  color: white;
  background-color: var(--bs-primary);
}

.step-nav-item.active i {
  color: white;
}


/* Étape complétée */
.step-nav-item.completed {
  background-color: var(--bs-primary);
  color: white;
  border-color: var(--bs-primary);
}

.step-nav-item.completed i {
  color: white;
}

/* Lignes entre les étapes */
.step-nav .col:not(:last-child):after {
  content: '';
  position: absolute;
  top: 50%;
  width: 100%;
  left: 50%;
  height: 1px;
  background-color: var(--bs-gray-400);
  transform: translateY(-50%);
}

.step-nav .col.completed:not(:last-child):after {
  background-color: var(--bs-primary);
}

</style>
